import Image from 'next/legacy/image'
import Link from 'next/link'
import Menu from '../icons/menu'
import Close from '../icons/close'
import kickoffLogoDark from 'images/kickoff-logo-dark.svg'
import s from './styles.module.css'
import { useState } from 'react'
import cx from 'classnames'
import { TopNav } from 'types/blog-types'
import NavbarCtaButton from './navbar-cta-button'

interface NavbarProps {
  template?: TopNav
}

export default function Navbar({ template }: NavbarProps) {
  const [showMenu, setShowMenu] = useState(false)

  const handleCollapsibleClick = e => {
    const content = e.currentTarget.lastChild
    if (content.style.maxHeight) {
      content.style.maxHeight = null
    } else {
      content.style.maxHeight = content.scrollHeight + 'px'
    }
  }

  return (
    <div className={s.navbar}>
      <div className={s.navbarContent}>
        <Link href="/" className={s.logoWrapper}>
          <Image
            src={kickoffLogoDark}
            alt="Kickoff"
            layout="fill"
            objectFit="contain"
          />
        </Link>
        <div className={s.mobileNavBtn} onClick={() => setShowMenu(!showMenu)}>
          {showMenu ? <Close /> : <Menu />}
        </div>
        <div className={cx(s.mobileMenu, { [s.show]: showMenu })}>
          <ul>
            {template.fields.menuItems.map(({ sys, fields: item }) => (
              <li
                key={sys.id}
                className={s.collapsible}
                onClick={handleCollapsibleClick}>
                <Link href={`/blog/${item.slug}`} className={s.link}>
                  {item.name}
                </Link>
              </li>
            ))}
            <li className={s.collapsible}>
              <NavbarCtaButton className={s.cta}>
                {template.fields.ctaButtonText}
              </NavbarCtaButton>
            </li>
          </ul>
        </div>
        <div className={s.desktopMenu}>
          {template.fields.menuItems.map(({ sys, fields: item }) => (
            <div
              key={sys.id}
              className={s.collapsible}
              onClick={handleCollapsibleClick}>
              <Link href={`/blog/${item.slug}`} className={s.link}>
                {item.name}
              </Link>
            </div>
          ))}
          <NavbarCtaButton className={s.cta}>
            {template.fields.ctaButtonText}
          </NavbarCtaButton>
        </div>
      </div>
    </div>
  )
}
